module.exports = __webpack_public_path__ + "img/5.957106ed.png";